import { combineReducers } from 'redux';
import { IManagerSubmittedSheetsFilter } from 'store/components/managerSubmittedSheets/managerSubmittedSheetsModel';
import {
    SET_MANAGER_SUBMITTED_SHEETS_FILTERS,
    setManagerSubmittedSheetsFilters,
} from 'store/components/managerSubmittedSheets/managerSubmittedSheetsActions';

const initialState = {
    filters: {
        location_id: '',
        position_id: '',
        user_id: '',
        pay_period: null,
        job_number_id: '',
    } as IManagerSubmittedSheetsFilter,
};

function filters(
    state: IManagerSubmittedSheetsFilter = initialState.filters,
    action: ReturnType<typeof setManagerSubmittedSheetsFilters>,
): IManagerSubmittedSheetsFilter {
    switch (action.type) {
        case SET_MANAGER_SUBMITTED_SHEETS_FILTERS:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}

export const managerSubmittedSheets = combineReducers({
    filters,
});
